import { takeLatest, call, put, select } from "redux-saga/effects";
import { USER_ADD_REQUEST, userAddError } from "../../actions/users";
import { role as roleSelector, ADMIN } from "../../selectors/auth";
import addSCUser from "../../../../../backend/oncall/administration/users/add";
import addPartnerUserAsAdmin from "../../../../../backend/oncall/administration/partners/users/add";
import addPartnerUser from "../../../../../backend/oncall/partners/users/add";
import { push } from "react-router-redux/actions";

const requestAdd = function*(action) {
  try {
    const role = yield select(roleSelector);
    const partnerId = action.payload.partnerId;
    if (partnerId) {
      yield call(
        addPartnerUserAsAdmin,
        partnerId,
        action.payload.formData.username,
        action.payload.formData.password,
        action.payload.formData.role === "ADMIN",
        action.payload.formData.enabled,
      );
      yield put(
        push(
          `/partner/users/edit/${action.payload.partnerId}/${
            action.payload.formData.username
          }`,
        ),
      );
    } else {
      const addUser = role === ADMIN ? addSCUser : addPartnerUser;
      yield call(
        addUser,
        action.payload.formData.username,
        action.payload.formData.password,
        action.payload.formData.role === "ADMIN",
        action.payload.formData.enabled,
      );
      yield put(push(`/user/edit/${action.payload.formData.username}`));
    }
  } catch (error) {
    yield put(userAddError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(USER_ADD_REQUEST, requestAdd);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/users/request-add.js